module.exports = __webpack_public_path__ + "static/img/diverses-370x290.6c49fe2d.jpg";